import React, { useEffect, useState } from 'react';
import { useAdminAuthStore } from '../stores/authStore';
import { useDashboardStore } from '../stores/dashboardStore';
import toast from 'react-hot-toast';
import { FaTrash, FaSearch } from 'react-icons/fa';
import { format } from 'date-fns';

export default function RecordingsPage() {
  const accessToken = useAdminAuthStore((state) => state.accessToken);
  const recordings = useDashboardStore((state) => state.recordings);
  const getRecordings = useDashboardStore((state) => state.getRecordings);
  const deleteRecording = useDashboardStore((state) => state.deleteRecording);
  const isLoading = useDashboardStore((state) => state.isLoading);
  const [searchTerm, setSearchTerm] = useState('');
  const [page, setPage] = useState(1);

  useEffect(() => {
    if (accessToken) {
      getRecordings(accessToken, page);
    }
  }, [accessToken, page]);

  const handleDelete = async (recordingId) => {
    if (window.confirm('Delete this recording?')) {
      try {
        await deleteRecording(accessToken, recordingId);
        toast.success('Recording deleted');
      } catch (error) {
        toast.error('Failed to delete recording');
      }
    }
  };

  const filteredRecordings = recordings.filter((r) =>
    r.file_name?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="max-w-7xl mx-auto px-4 py-8">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900">Recording Management</h1>
        <p className="text-gray-600 mt-1">Manage video recordings</p>
      </div>

      <div className="mb-6">
        <div className="relative">
          <FaSearch className="absolute left-3 top-3 text-gray-400" size={18} />
          <input
            type="text"
            placeholder="Search recordings..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none"
          />
        </div>
      </div>

      {isLoading ? (
        <div className="flex justify-center py-12">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
        </div>
      ) : (
        <div className="dashboard-card overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b">
                <th className="text-left p-4 font-semibold text-gray-700">File</th>
                <th className="text-left p-4 font-semibold text-gray-700">Duration</th>
                <th className="text-left p-4 font-semibold text-gray-700">Size</th>
                <th className="text-left p-4 font-semibold text-gray-700">Status</th>
                <th className="text-left p-4 font-semibold text-gray-700">Created</th>
                <th className="text-left p-4 font-semibold text-gray-700">Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredRecordings.length === 0 ? (
                <tr>
                  <td colSpan="6" className="text-center py-8 text-gray-500">
                    No recordings found
                  </td>
                </tr>
              ) : (
                filteredRecordings.map((rec) => (
                  <tr key={rec.id} className="table-row">
                    <td className="p-4 text-sm">{rec.file_name}</td>
                    <td className="p-4 text-sm">{rec.formatted_duration || 'N/A'}</td>
                    <td className="p-4 text-sm">{rec.formatted_file_size || 'N/A'}</td>
                    <td className="p-4">
                      <span className="badge-success">{rec.status}</span>
                    </td>
                    <td className="p-4 text-sm">
                      {format(new Date(rec.created_at), 'MMM dd, yyyy')}
                    </td>
                    <td className="p-4">
                      <button
                        onClick={() => handleDelete(rec.id)}
                        className="btn-danger btn-sm"
                      >
                        <FaTrash size={14} />
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
